"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentsThatExtendExpiration = exports.getFoundations = exports.doesDocumentExtendExpiration = exports.isDocumentFoundation = exports.documentsWhichIsFoundations = exports.documentsThatExtendExpirationInDenmark = exports.DocumentTypesHumanized = exports.DocumentTypes = exports.RefIdTypes = void 0;
const moment_1 = __importDefault(require("moment"));
var RefIdTypes;
(function (RefIdTypes) {
    RefIdTypes["CASE"] = "CASE";
    RefIdTypes["CREDITOR"] = "CREDITOR";
    RefIdTypes["TENANT"] = "TENANT";
})(RefIdTypes || (exports.RefIdTypes = RefIdTypes = {}));
var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["FOUNDATION"] = "FOUNDATION";
    DocumentTypes["SKYLDERKLAERING"] = "SKYLDERKLAERING";
    DocumentTypes["COURTOPGJORTOGFREMLAGT"] = "COURTOPGJORTOGFREMLAGT";
    DocumentTypes["DOM"] = "DOM";
    DocumentTypes["FORLIG"] = "FORLIG";
    DocumentTypes["COURT"] = "COURT";
    DocumentTypes["OTHER"] = "OTHER";
    DocumentTypes["GAELDSBREV"] = "GAELDSBREV";
})(DocumentTypes || (exports.DocumentTypes = DocumentTypes = {}));
exports.DocumentTypesHumanized = {
    [DocumentTypes.FOUNDATION]: ['Fundament'],
    [DocumentTypes.SKYLDERKLAERING]: ['Skylderklæring'],
    [DocumentTypes.COURTOPGJORTOGFREMLAGT]: ['Opgjort og fremlagt i retten'],
    [DocumentTypes.DOM]: ['Dom'],
    [DocumentTypes.FORLIG]: ['Forlig'],
    [DocumentTypes.COURT]: ['Retligt'],
    [DocumentTypes.OTHER]: ['Andet'],
    [DocumentTypes.GAELDSBREV]: ['Gældsbrev'],
};
exports.documentsThatExtendExpirationInDenmark = {
    signingNotRequired: [
        DocumentTypes.DOM,
        DocumentTypes.COURTOPGJORTOGFREMLAGT,
        DocumentTypes.GAELDSBREV,
    ],
    signingRequired: [
        DocumentTypes.FOUNDATION,
        DocumentTypes.SKYLDERKLAERING,
        DocumentTypes.FORLIG,
    ],
};
exports.documentsWhichIsFoundations = {
    signingNotRequired: [DocumentTypes.DOM, DocumentTypes.GAELDSBREV],
    signingRequired: [
        DocumentTypes.FOUNDATION,
        DocumentTypes.SKYLDERKLAERING,
        DocumentTypes.FORLIG,
    ],
};
const isDocumentFoundation = (document) => {
    if (exports.documentsWhichIsFoundations.signingNotRequired.includes(document.type)) {
        return true;
    }
    if (exports.documentsWhichIsFoundations.signingRequired.includes(document.type) &&
        document.signedAt) {
        return true;
    }
    return false;
};
exports.isDocumentFoundation = isDocumentFoundation;
const doesDocumentExtendExpiration = (document) => {
    if (exports.documentsThatExtendExpirationInDenmark.signingNotRequired.includes(document.type)) {
        return true;
    }
    if (exports.documentsThatExtendExpirationInDenmark.signingRequired.includes(document.type) &&
        document.signedAt) {
        return true;
    }
    return false;
};
exports.doesDocumentExtendExpiration = doesDocumentExtendExpiration;
const getFoundations = (documents) => {
    const foundations = documents.filter(exports.isDocumentFoundation);
    if (foundations.length > 1) {
        foundations.sort((a, b) => {
            if ((0, moment_1.default)(a.date) > (0, moment_1.default)(b.date)) {
                return -1;
            }
            else if ((0, moment_1.default)(a.date) < (0, moment_1.default)(b.date)) {
                return 1;
            }
            return 0;
        });
    }
    return foundations;
};
exports.getFoundations = getFoundations;
const getDocumentsThatExtendExpiration = (documents) => {
    return documents.filter(exports.doesDocumentExtendExpiration);
};
exports.getDocumentsThatExtendExpiration = getDocumentsThatExtendExpiration;
//# sourceMappingURL=index.js.map